module.exports = __webpack_public_path__ + "static/icons/icon-user-f690ffc28ef97d516f069291ed626f8c.svg";